import { render, staticRenderFns } from "./AdminLearningProgressions.vue?vue&type=template&id=13f8e37e"
import script from "./AdminLearningProgressions.vue?vue&type=script&lang=js"
export * from "./AdminLearningProgressions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports